/**
 * Lot 2c — résolution KPI catalogue Admin (PHYSIQUE / SERVICE + fallback legacy).
 */

/**
 * @param {object|null|undefined} commercant
 * @param {{ produits?: array, prestations?: array }} [lists]
 * @returns {{
 *   totalProduits: number,
 *   totalPrestations: number,
 *   kpiPrestationsSource: 'PRODUIT_SERVICE'|'PRESTATION_LEGACY'
 * }}
 */
export function resolveAdminCatalogKpis(
  commercant,
  { produits = [], prestations = [] } = {},
) {
  const phys =
    typeof commercant?.countProduitsPhysiques === 'number'
      ? commercant.countProduitsPhysiques
      : typeof commercant?.kpiProduits === 'number'
        ? commercant.kpiProduits
        : (produits || []).filter((p) => p?.actif !== false && p?.typeProduit === 'PHYSIQUE')
            .length

  const service =
    typeof commercant?.countProduitsService === 'number'
      ? commercant.countProduitsService
      : (produits || []).filter((p) => p?.actif !== false && p?.typeProduit === 'SERVICE').length

  const legacy =
    typeof commercant?.countPrestationsLegacy === 'number'
      ? commercant.countPrestationsLegacy
      : (prestations || []).filter((p) => p?.actif !== false).length

  let totalPrestations
  let kpiPrestationsSource
  if (typeof commercant?.kpiPrestations === 'number' && commercant?.kpiPrestationsSource) {
    totalPrestations = commercant.kpiPrestations
    kpiPrestationsSource = commercant.kpiPrestationsSource
  } else if (service > 0) {
    totalPrestations = service
    kpiPrestationsSource = 'PRODUIT_SERVICE'
  } else {
    totalPrestations = legacy
    kpiPrestationsSource = 'PRESTATION_LEGACY'
  }

  return {
    totalProduits: phys,
    totalPrestations,
    kpiPrestationsSource,
  }
}
